import { internalChatMessages } from 'messages';
import { OmniChannelMessageDto, OmniChannelSenderDto } from 'types';

export const calculateHeightOmniMessageError = (
  message: OmniChannelMessageDto,
  props?: {
    isFirstOfSender?: boolean;
    isGroup?: boolean;
    isMe?: boolean;
    sender?: OmniChannelSenderDto;
  },
  maxWidth = 300
): number => {
  if (!message) return 0;

  const clone = document.createElement('div');
  clone.className =
    'relative flex min-w-[70px] max-w-[300px] items-center whitespace-pre-wrap break-words rounded-full pl-[28px] pr-[50px] text-center text-xs leading-6';

  clone.style.maxWidth = `${maxWidth}px`;
  clone.innerHTML = `${props?.isMe ? internalChatMessages.you : props?.sender?.senderName} ${message.content}`;
  document.body.appendChild(clone);
  const height = clone.offsetHeight;
  document.body.removeChild(clone);
  return height;
};
